import { axios } from '../utils/request_new'

/* 获取用户设备列表 */
export function getUserDevice() {
  return axios({
    url: '/device/user/all/devices',
    method: 'GET',
  })
}

/* 修改设备名字 */
export function editDeviceName(data = { name: '', sn: '' }) {
  return axios({
    url: '/device/device/name',
    method: 'PUT',
    params: data,
  })
}

/* 用户解绑设备 */
export function unbindDevice(data = { sn: '' }) {
  const { sn } = data
  return axios({
    url: `/device/user/device/unbind/${sn}`,
    method: 'DELETE',
  })
}

/* 获取设备分享成员 */
export function getDeviceShareMember(params = { sn: '' }) {
  return axios({
    url: '/device/user/share/member',
    method: 'GET',
    params
  })
}

/* 获取用户邀请码 */
export function getDeviceShareCode(params = { sn: '' }) {
  return axios({
    url: `/device/user/${params.sn}/invitation-code`,
    method: 'GET'
  })
}

/* 移除单个分享用户 */
export function removeShareByUid(data = { sn: '', userId: '' }) {
  return axios({
    url: `/device/user/remove/share`,
    method: 'DELETE',
    params: data
  })
}

/* 导出空表格 */
export function getEmptyDeviceExcel() {
  return axios({
    url: `/device/empty-excel`,
    method: 'GET',
    responseType: 'blob',
  })
}

/* 分页获取用户设备列表 */
export function getPageUserDevice(params = { page: 1, pageSize: 10 }) {
  // const { page, pageSize, keyword, typeName, activateStatus } = params
  return axios({
    url: `/device/user/page/devices`,
    method: 'GET',
    params
  })
}

/* 查询导入任务 */
export function getExcelResult(params = { taskId: '' }) {
  return axios({
    url: `/device/excel/result`,
    method: 'GET',
    params
  })
}

/* 表格导入 */
export function importExcel(data) {
  return axios({
    url: `/device/import-excel`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  })
}

/* 表格导出 */
export function exportExcel(data) {
  return axios({
    url: `/device/export-excel`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

/* 获取设备类型描述列表 */
export function getDeviceConfigs() {
  return axios({
    url: `/device/user/type/config`,
    method: 'GET'
  })
}

export default {
  getUserDevice,
  editDeviceName,
  unbindDevice,
  getDeviceShareMember,
  getDeviceShareCode,
  removeShareByUid,
  getEmptyDeviceExcel,
  getPageUserDevice,
  getExcelResult,
  importExcel,
  exportExcel,
  getDeviceConfigs
}